import type { AxiosError } from 'axios'

const PAYLOAD_TOO_LARGE_STATUS = 413
const PAYLOAD_TOO_LARGE_MESSAGE = 'Uploaded file is too large. Please choose a smaller file.'

/**
 * Lấy chuỗi lỗi từ response API (error → message) hoặc Error.message.
 * Dùng chung cho toast / form khi mutate thất bại.
 */
export function getApiErrorText(error: unknown): string | undefined {
  const response = (error as AxiosError<{ error?: string; message?: string }>).response
  if (response?.status === PAYLOAD_TOO_LARGE_STATUS) {
    return PAYLOAD_TOO_LARGE_MESSAGE
  }

  const data = response?.data
  const fromError = typeof data?.error === 'string' ? data.error.trim() : ''
  if (fromError) return fromError
  const fromMessage = typeof data?.message === 'string' ? data.message.trim() : ''
  if (fromMessage) return fromMessage
  if (error instanceof Error && error.message.trim()) return error.message
  return undefined
}
